import apiHelper from '@/services/helper'

const getShopIdByUserCode = async (param) => {
    try {
        let url = '/admin/shop/search-list'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getUserDevices = async (param) => {
    try {
        let url = '/admin/logging/order/get/devices'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getTimerData = async (param) => {
    try {
        let url = '/admin/logging/order/get/timer'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default { getUserDevices, getTimerData, getShopIdByUserCode }
